import React, { useEffect, useState } from "react";
import { User } from "~/common/Store/models/User";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import { useGlobalContext } from "~/ProductDetails/useGlobalContext";
import InstallationService from "./InstallationService";
import ExtendedWarrantyContainer from "./ExtendedWarranty/ExtendedWarrantyContainer";
import useIsMounted from "~/common/useIsMounted";
import { ExtendedWarranty } from "~/ProductDetails/ProductDetailPageResult";
import { WarrantyOption } from "~/common/AddToCartModal";
import isGroupMemberSelected from "../../isGroupMemberSelected";
import ValidationError from "../ValidationError";
import getInstallationServicePricingData, { InstallationPricing } from "./InstallationService/getInstallationServicePricingData";
interface Props {
  product: PricingProduct;
  user: User;
  quantity: number;
  setInstallationServiceIds: (ids: number[]) => void;
  selectedWarranty?: ExtendedWarranty;
  onSubmit: (result: WarrantyOption) => void;
  handleAddToCartError: (validationError: ValidationError | undefined) => void;
  handleSetErrorMessage: (errorMessage: string) => void;
  isInternationalUser: boolean;
}
const WhatWeOffer = ({
  product,
  user,
  quantity,
  setInstallationServiceIds,
  selectedWarranty,
  onSubmit,
  handleAddToCartError,
  handleSetErrorMessage,
  isInternationalUser
}: Props) => {
  const {
    displayInstallationService,
    extendedWarranties,
    itemNumberId,
    serviceTierId
  } = product;
  const mounted = useIsMounted();
  const [showInstallation, setShowInstallation] = useState(false);
  const {
    setIsZipcodeEligibleForInstallationService
  } = useGlobalContext();

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const [pricingData, setPricingData] = useState({
    finalConnections: {
      price: 0
    },
    fourToNinetyNineFlights: {
      price: 0
    },
    fullService: {
      price: 0
    },
    haulAway: {
      price: 0
    },
    oneToThreeFlights: {
      price: 0
    },
    survey: {
      price: 0
    },
    surveyNoCharge: {
      price: 0
    }
  } as InstallationPricing);
  const hasSelectedGroupMember = isGroupMemberSelected(product);
  useEffect(() => {
    let isCancelled = false;
    const getEligibilityForInstallationService = async (zipcode: string) => {
      const result = await getInstallationServicePricingData(serviceTierId, zipcode, itemNumberId);
      if (!isCancelled) {
        if (result) {
          setIsZipcodeEligibleForInstallationService(true);
          setShowInstallation(true);
          setPricingData(result);
        } else {
          setIsZipcodeEligibleForInstallationService(false);
          setShowInstallation(false);
        }
      }
    };
    if (displayInstallationService && hasSelectedGroupMember && user.registered && user.isCommercial && user.facebookUserData.zp) {
      getEligibilityForInstallationService(user.facebookUserData.zp);
    }
    return () => {
      isCancelled = true;
    };
  }, [displayInstallationService, hasSelectedGroupMember, itemNumberId, serviceTierId, setIsZipcodeEligibleForInstallationService, user.facebookUserData.zp, user.isCommercial, user.registered]);

  // removes installation services option when logged out without needing to hard refresh to see change
  useEffect(() => {
    if (!user || !user.registered || !user.isCommercial || !user.facebookUserData?.zp) {
      setShowInstallation(false);
    }
  }, [user]);
  const showWarranty = extendedWarranties?.length > 0;
  const showWhatWeOffer = (user.registered && !isInternationalUser || !user.registered) && (showInstallation || showWarranty);
  return <>
      {mounted && showWhatWeOffer && <>
          <p className="text-gray-800 text-left" style={{
        paddingBottom: "5px"
      }}>
            <strong>What We Offer</strong>
          </p>
          {showWarranty && <ExtendedWarrantyContainer product={product} hasSelectedGroupMember={hasSelectedGroupMember} onSubmit={onSubmit} selectedWarranty={selectedWarranty} handleAddToCartError={handleAddToCartError} handleSetErrorMessage={handleSetErrorMessage} />}
          {showInstallation && <InstallationService serviceLevelId={product.serviceLevelId} quantity={quantity} setInstallationServiceIds={setInstallationServiceIds} pricingData={pricingData} />}
        </>}
    </>;
};
export default WhatWeOffer;